import { FileText, Receipt } from "lucide-react";
import { proformaUrl, ron } from "@/lib/bf";

const when = (iso) => new Date(iso).toLocaleDateString("ro-RO", { day: "numeric", month: "short", year: "numeric" });

export default function BFClientOrders({ rows, total }) {
  return (
    <section className="invite-box bfc-sec" data-testid="bfc-orders">
      <h3><Receipt size={16} /> Comenzi și proforme · {ron(total)}</h3>
      {!rows.length && <p className="st-hint" data-testid="bfc-orders-empty">Salonul nu are încă nicio comandă.</p>}
      <ul className="bfc-orders">
        {rows.map((r) => (
          <li key={r.id} data-testid={`bfc-order-${r.id}`}>
            <b>{r.no}</b><small>{when(r.created_at)}</small><span>{ron(r.total)}</span>
            <a className="st-btn st-btn--ghost" href={`${proformaUrl(r.id)}.xlsx`} data-testid={`bfc-order-xlsx-${r.id}`}><FileText size={14} /> Excel</a>
          </li>
        ))}
      </ul>
    </section>
  );
}
